import { format, endOfDay } from 'date-fns';

import type { CourseEntity } from '@modules/courses/entities';
import type {
    Platform,
    LapCreateArgs,
    LapProgramType,
    LapPlatoonsConfigItem,
} from '@modules/types/graphql';

export type CreateLapFormValues = {
    programType: LapProgramType | '';
    from: Date | null;
    to: Date | null;
    platform: Platform | '';
    course: CourseEntity | null;
    platoonsCompanyCount: string;
    platoonsByCompanies: [number, string][];
};

class CreateLapRequest {
    programType: LapCreateArgs['programType'];
    from: LapCreateArgs['from'];
    to: LapCreateArgs['to'];
    platform: LapCreateArgs['platform'];
    courseId: LapCreateArgs['courseId'];
    platoonsConfig: LapCreateArgs['platoonsConfig'];

    constructor(values: CreateLapFormValues) {
        this.programType = (values.programType as LapProgramType) || undefined;
        this.from = values.from ? format(endOfDay(values.from), 'yyyy-MM-dd') : undefined;
        this.to = values.to ? format(endOfDay(values.to), 'yyyy-MM-dd') : undefined;
        this.platform = (values.platform as Platform) || undefined;
        this.courseId = values.course?.id;

        this.platoonsConfig = values.platoonsByCompanies.reduce((carry, [company, platoons]) => {
            const item: LapPlatoonsConfigItem = {
                company,
                platoons: +platoons,
            };

            carry.push(item);

            return carry;
        }, [] as LapPlatoonsConfigItem[]);
    }
}

export { CreateLapRequest };
